import { Tag } from "antd";
import ImageUploadButton from "../website/ImageUploaderButton";

const imageConfigurations = [
  { id: 1, aspectRatioText: "16:9", aspectRatioValue: 16 / 9 },
  { id: 2, aspectRatioText: "16:9", aspectRatioValue: 16 / 9 },
  { id: 3, aspectRatioText: "16:9", aspectRatioValue: 16 / 9 },
  { id: 4, aspectRatioText: "1:1",  aspectRatioValue: 1 / 1  },
];

const DirectoryImages = ({ groupImages, handleImageChange }) => {
  return (
    <div>
      <h5 className="group-listing-section-title">Group Images</h5>
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {imageConfigurations.map((item) => (
          <div
            key={item.id}
            style={{ display: "flex", alignItems: "center", gap: 16 }}
          >
            <div style={{ width: 110, flexShrink: 0 }}>
              <div style={{ fontWeight: 500, fontSize: 14, color: "#333" }}>
                Image #{item.id}
              </div>
              <Tag
                style={{ marginTop: 4, fontSize: 11, padding: "0 6px" }}
              >
                {item.aspectRatioText}
              </Tag>
            </div>
            <ImageUploadButton
              text="Upload"
              aspectRatio={item.aspectRatioValue}
              images={[groupImages[`image${item.id}`]]}
              tooltip={`Image will be cropped at an aspect ratio of ${item.aspectRatioText}`}
              onSave={(images) =>
                handleImageChange(`image${item.id}`, images[0])
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DirectoryImages;
